import styled from 'styled-components'
import { colors, updatedMedia } from 'client/styles'
import { ButtonReset } from 'src/comps/Button/styles'

export const FacilitiesBase = styled.section`
  background-color: ${props => props.theme.colors.grey8};
  padding-block: 20px;
  padding-inline: 0;

  .facilities-grid {
    display: flex;
    width: auto;
    gap: 30px;
  }
`

export const Title = styled.h2`
  color: ${props => props.theme.colors.grey2};
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  margin-block-end: 1em;

  ${updatedMedia.tablet} {
    font-size: 28px;
  }
`

export const List = styled.ul`
  color: ${props => props.theme.colors.grey3};

  li {
    margin-block-end: 12px;
  }
`

export const Category = styled.div`
  margin-block-end: 30px;
  ${updatedMedia.tablet} {
    &:last-child {
      margin-block-end: 0;
    }
  }
`

export const More = styled(ButtonReset)`
  color: ${colors.grey1};
  font-weight: 500;
  margin-block-start: 10px;
  text-decoration: underline;
`

export const FacilityCategoryBase = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-block-end: 12px;

  h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: ${props => props.theme.colors.grey2};
  }

  svg {
    fill: ${props => props.theme.colors.grey2};
    height: 24px;
    width: 24px;
    margin-inline-end: 8px;
  }
`
